import { registerCollectionStrings } from "../collection-strings";
import { en } from "./en";
import { ja } from "./ja";
import { zhTW } from "./zh-TW";

/**
 * Registers every collection-string bundle.
 *
 * Imported once for its side effect, from `App.tsx`, before any collection is
 * built. Kept as a registry rather than a plain export map so a new locale is
 * one line here plus one file, and `collection-strings.ts` — which every
 * collection imports — never has to import the bundles back.
 */
registerCollectionStrings("en", en);
registerCollectionStrings("zh-TW", zhTW);
registerCollectionStrings("ja", ja);
